/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Player { 
    full_name: string;
    t_shirt_number?: number | null;
    position?: string | null;
    date_of_birth?: string | null;
    height_in_cm?: number | null;
    weight_in_kg?: number | null;
    id: string;
    created_at?: string | null;
    updated_at?: string | null;
}

